import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { BadgeCheck, MapPin } from "lucide-react";
import { api } from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import { Reveal } from "@/components/Reveal";

export default function SellerProfile() {
  const { id } = useParams();
  const [seller, setSeller] = useState(null);

  useEffect(() => {
    setSeller(null);
    api.get(`/sellers/${id}`).then(({ data }) => setSeller(data)).catch(() => setSeller(false));
  }, [id]);

  if (seller === null) return <div className="min-h-screen grid place-items-center text-mute">Loading…</div>;
  if (!seller) return <div className="min-h-screen grid place-items-center text-mute">Seller not found.</div>;

  return (
    <div className="pt-24 sm:pt-28 pb-24 min-h-screen">
      {/* header */}
      <div className="bg-forest text-sand">
        <div className="max-w-[1400px] mx-auto px-5 sm:px-8 py-16 sm:py-20">
          <div className="overline text-terra mb-4">Maker profile</div>
          <div className="flex flex-wrap items-center gap-4">
            {seller.shop_logo && (
              <img src={seller.shop_logo} alt={`${seller.name} logo`} className="w-16 h-16 sm:w-20 sm:h-20 rounded-full object-cover border-2 border-terra/50" data-testid="seller-logo" />
            )}
            <h1 className="font-serif text-4xl sm:text-6xl tracking-tighter">{seller.name}</h1>
            {seller.seller_verified && <BadgeCheck className="w-7 h-7 text-terra" />}
          </div>
          <p className="text-terra mt-2">{seller.specialty}</p>
          {seller.ships_from && (
            <p className="text-sand/60 text-sm mt-2 inline-flex items-center gap-1.5" data-testid="seller-ships-from">
              <MapPin className="w-4 h-4" /> Ships from {seller.ships_from}
            </p>
          )}
          <p className="text-sand/70 mt-5 max-w-xl leading-relaxed">{seller.bio}</p>
        </div>
      </div>

      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 mt-14">
        <Reveal>
          <h2 className="font-serif text-3xl sm:text-4xl tracking-tight mb-8">
            The catalog <span className="text-mute text-lg">· {seller.products.length} pieces</span>
          </h2>
        </Reveal>
        {seller.products.length === 0 ? (
          <p className="text-mute py-16 text-center">This maker hasn't listed any products yet.</p>
        ) : (
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
            {seller.products.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
          </div>
        )}
      </div>
    </div>
  );
}
